import React, { ReactElement } from 'react';
import cx from 'classnames';

import styles from './ArticlesTagsGroupDivider.module.scss';

interface IArticlesTagsGroupDividerProps {
  className?: string;
}

const ArticlesTagsGroupDivider = ({ className }: IArticlesTagsGroupDividerProps): ReactElement => {
  return <div className={cx(styles.container, className)} />;
};

export default ArticlesTagsGroupDivider;
